import { type Types } from '@fiverr-private/theme';
import { formsTokenColors } from '../shared/formsTokenColors';

export interface IGetTextareaStylingProps {
    borderColor: Types.SelectorBorderColorsType;
    disabled?: boolean;
    focusBorderColor: Types.BorderColor;
    focusType: 'focus' | 'focusWithin';
}

export const getTextareaStylingProps = ({
    borderColor,
    disabled,
    focusBorderColor,
    focusType,
}: IGetTextareaStylingProps): Types.ContainerProps => ({
    display: 'flex',
    cursor: 'auto',
    borderWidth: 'sm',
    borderStyle: 'solid',
    borderRadius: 'lg',
    borderColor,
    backgroundColor: disabled ? 'grey_200' : 'background',
    outlineColor: {
        [focusType]: focusBorderColor,
    },
    outlineWidth: {
        [focusType]: 'sm',
    },
    outlineStyle: {
        [focusType]: 'solid',
    },
    pointerEvents: disabled ? 'none' : undefined,
    color: disabled ? formsTokenColors.disabledColor : formsTokenColors.color,
});
